
export default {
    baseurl: localStorage.getItem('mode') === 'staging' ? 'http://indybuildpro.com:3000/' : 'https://api.indybuild.com/',
    getPendingPosts: "api/admin/posts",
    authTokenKey: "admin-token-ib",
    userInfo: "current_user",
    getUsers: "api/statistics/getUsers",
    deleteUser: "api/admin/user-delete/",
    contacts: "api/statistics/getFeedback",
    login: 'auth/login',
    updatepoststatus: 'api/v2/admin/updateStatus',
    adminKey: 'IB.IndyBuildAdmin-74',
    getAllPosts: "api/admin/posts",
    getRejectedPosts: "api/admin/rejected-posts",
    getPostById: 'api/getPublicPostById'
};
